import { Button, Dropdown, Icon, Input, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import styles from './SelectCompany.module.scss';
import { getQueryKeys } from '../../HousingStock/queries/queryKeys';
import { setCurrentCompany } from '../store/actions/actions';
import { getReplacedString } from '../../../helpers/getReplacedString';
import CheckMarkMenu from '../../../components/CheckMarkMenu/CheckMarkMenu';
import cn from 'classnames';
import { useHistory } from 'react-router-dom';

export const SelectCompanyBase = ({
  currentCompany,
  companies,
  onChange,
  className,
  disabled,
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);

  const textRef = useRef(null);

  const handleMenuClick = (item) => {
    if (disabled) return;

    const companyId = item.id;
    onChange({ item, companyId });
    setDropdownVisible(false);
  };

  const handleVisibleChange = (visible) => {
    setDropdownVisible(disabled ? false : visible);
  };

  const handleSearch = (e) => {
    const val = e.target.value;
    const value = getReplacedString(val);

    setFilteredCompanies(
      companies.filter((company) =>
        getReplacedString(company.name).includes(value)
      )
    );

    setSearchValue(val);
  };

  useEffect(() => {
    if (companies?.length) {
      setFilteredCompanies(companies);
    }
  }, [companies]);

  useEffect(() => {
    if (!dropdownVisible) {
      setSearchValue('');
      setFilteredCompanies(companies || []);
    }
  }, [dropdownVisible, companies]);

  useEffect(() => {
    const checkOverflow = () => {
      const element = textRef.current;
      if (!element) return;

      setShowTooltip(element.scrollWidth > element.offsetWidth);
    };

    window.addEventListener('resize', checkOverflow);
    checkOverflow();

    return () => window.removeEventListener('resize', checkOverflow);
  }, [currentCompany]);

  return (
    <Dropdown
      trigger={['click']}
      visible={dropdownVisible}
      onVisibleChange={handleVisibleChange}
      placement="bottomRight"
      overlay={
        <CheckMarkMenu
          items={filteredCompanies}
          selectedItems={[currentCompany?.id]}
          renderContent={(item) => item.name}
          visible={dropdownVisible}
          renderSearchInput={({ inputRef }) => (
            <Input
              ref={inputRef}
              onChange={handleSearch}
              value={searchValue}
            />
          )}
          handlers={{ onMenuClick: handleMenuClick }}
        />
      }
    >
      <Tooltip
        title={showTooltip && (currentCompany?.name || 'Управляющая компания')}
      >
        <Button className={cn(styles.button, styles['gray'], className)}>
          <span
            ref={textRef}
            style={{
              display: 'inline-block',
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {currentCompany?.name || 'Управляющая компания'}
          </span>
          <Icon type="caret-down" />
        </Button>
      </Tooltip>
    </Dropdown>
  );
};

const SelectCompany = () => {
  const queryClient = useQueryClient();

  const dispatch = useDispatch();
  const history = useHistory();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const companies = queryClient.getQueryData(getQueryKeys.companies());

  const handleChange = ({ companyId }) => {
    if (companyId !== currentCompany?.id) {
      const companySelect = companies?.find((item) => item.id === companyId);

      dispatch(setCurrentCompany(companySelect));

      history.push({
        pathname: '/Debts',
        search: `?companyId=${companyId}`,
      });
    }
  };

  return (
    <SelectCompanyBase
      currentCompany={currentCompany}
      companies={companies}
      onChange={handleChange}
      className={styles.companiesDropdownBtn}
    />
  );
};

export default SelectCompany;
